import { UserStore } from '@yarmill/types';

export function sortUserStoresByStatus(a: UserStore, b: UserStore): number {
  return (
    Number(a.internalUser.AccountStateId) -
    Number(b.internalUser.AccountStateId)
  );
}
